Pluswerk.PlusProject.CookieBar = Pluswerk.PlusProject.CookieBar || {};
/**
 * CookieBarControllerController
 *
 * @author Manuel Müller <manuel.mueller@pluswerk.ag>
 */
Pluswerk.PlusProject.CookieBar.CookieBarController = function () {
  var selectorCookieBar = '.js-cookie-bar';
  var selectorCloseButton = '.js-close-cookie-bar';
  var $cookieBar = $(selectorCookieBar);
  var animationSpeed = 300;
  var cookieName = 'accept_cookie';
  var cookieValue = 'true';

  /**
   * initOnce
   */
  var initOnce = function () {
    initCloseButton();
    setCookieName();
    if (getCookie(cookieName) !== cookieValue) {
      $cookieBar.fadeIn(animationSpeed);
    }
  };

  /**
   * initCloseButton
   */
  var initCloseButton = function () {
    $(selectorCloseButton).click(function () {
      closeCookieBar();
      return false;
    });
  };

  /**
   * setCookieName
   */
  var setCookieName = function () {
    if ($cookieBar.attr('data-fair')) {
      cookieName = $cookieBar.data('fair') + '_cookie';
    }
  };

  /**
   * closeCookieBar
   */
  var closeCookieBar = function () {
    setCookie(cookieName, cookieValue, 31);
    $cookieBar.fadeOut(animationSpeed);
  };

  /**
   * @param {string} name
   * @param {string} value
   * @param {number} days
   */
  var setCookie = function (name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
    var expires = 'expires=' + d.toUTCString();
    document.cookie = name + '=' + value + '; ' + expires + '; path=/';
  };

  /**
   * @param {string} name
   * @returns {string}
   */
  var getCookie = function (name) {
    name += '='; // eslint-disable-line no-param-reassign
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1);
      if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
    }
    return '';
  };

  initOnce();
};
